import React from 'react';
import { Spinner } from 'react-bootstrap';
import { fmt, fmtUnit } from '../utils/helpers';

// unit : respecte le sélecteur d'unité de la section parente

const BORD_H   = '1px solid rgba(255,255,255,0.2)';
const BORD_D   = '1px solid #dedad6';
const BORD_SEP = '2px solid #c8c8c8';

const TH_GRAY = {
  background: '#4a505c', color: '#fff', padding: '6px 10px',
  textAlign: 'center', fontWeight: 700, fontSize: '0.68rem',
  whiteSpace: 'nowrap', borderTop: BORD_H, borderBottom: BORD_H,
  borderLeft: BORD_H, borderRight: BORD_H,
};
const td = (extra = {}) => ({
  padding: '6px 10px', textAlign: 'right', fontSize: '0.76rem',
  whiteSpace: 'nowrap', borderTop: BORD_D, borderBottom: BORD_D,
  borderLeft: BORD_D, borderRight: BORD_D, ...extra,
});

const TableauStockDestockage = ({ data, loading, unit, onCellClick }) => {
  if (loading) return <div style={{ padding: '20px 0', textAlign: 'center' }}><Spinner /></div>;
  if (!data.length) return null;

  const fu = (v) => fmtUnit(v, unit);

  const tot = data.reduce((a, r) => ({
    stockInitial: a.stockInitial + r.stockInitial,
    cumulVendu:   a.cumulVendu   + r.cumulVendu,
    periodeVendu: a.periodeVendu + r.periodeVendu,
    chiffreAffaire: a.chiffreAffaire + r.chiffreAffaire,
  }), { stockInitial: 0, cumulVendu: 0, periodeVendu: 0, chiffreAffaire: 0 });
  const totPct = tot.stockInitial > 0 ? (tot.cumulVendu / tot.stockInitial) * 100 : null;

  const Td = ({ v, f = fu, bold, color, foot, onClick }) => (
    <td style={td({
      color: color || (foot ? '#fff' : '#333'),
      fontWeight: bold ? 700 : 400,
      background: foot ? '#363c48' : 'inherit',
      cursor: onClick ? 'pointer' : 'default',
      textDecoration: onClick ? 'underline' : 'none',
      textDecorationColor: onClick ? 'rgba(0,0,0,0.15)' : 'transparent',
    })} onClick={onClick}>{f(v)}</td>
  );
  const TdDash = ({ foot }) => (
    <td style={td({ color: foot ? 'rgba(255,255,255,0.25)' : '#ddd', background: foot ? '#363c48' : 'inherit' })}>—</td>
  );
  const Pct = ({ v, foot }) => v == null
    ? <TdDash foot={foot} />
    : <Td v={v} f={(x) => `${Math.round(x)}%`} bold color={foot ? '#fff' : '#333'} foot={foot} />;

  return (
    <div style={{ marginTop: 0, borderRadius: 6, border: '2px solid #8090a4', overflow: 'hidden' }}>
      <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: '0.76rem', width: '100%', minWidth: 760 }}>
        <thead>
          <tr>
            <th style={{ ...TH_GRAY, textAlign: 'left', padding: '7px 14px', background: '#363c48' }}>Tranche</th>
            <th style={{ ...TH_GRAY, textAlign: 'left', padding: '7px 14px', background: '#363c48', borderRight: BORD_SEP }}>Type</th>
            <th style={TH_GRAY}>Stock initial</th>
            <th style={TH_GRAY}>Vendu/Déstocké (cumul)</th>
            <th style={TH_GRAY}>% Vendu/Livré</th>
            <th style={TH_GRAY}>Vendu/Déstocké (période)</th>
            <th style={TH_GRAY}>Chiffre d'affaires</th>
            <th style={TH_GRAY}>Prix de revient</th>
            <th style={TH_GRAY}>Marge (DH)</th>
            <th style={TH_GRAY}>% Marge</th>
            <th style={TH_GRAY}>Prix moyen (DH)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((r, i) => {
            const bg = i % 2 === 0 ? '#fff' : '#f7f6f4';
            return (
              <tr key={`${r.tranche}__${r.type}`} style={{ background: bg }}
                onMouseEnter={e => { e.currentTarget.style.background = '#efefee'; }}
                onMouseLeave={e => { e.currentTarget.style.background = bg; }}>
                <td style={{ ...td({ background: '#e8e7e5', color: '#2a2a2a', fontWeight: 700, textAlign: 'left', borderLeft: 'none' }) }}>
                  {r.tranche || '—'}
                </td>
                <td style={{ ...td({ background: '#e8e7e5', color: '#2a2a2a', fontWeight: 700, textAlign: 'left', borderRight: BORD_SEP, borderLeft: 'none' }) }}>
                  {r.type}
                </td>
                <Td v={r.stockInitial} f={fmt} bold onClick={onCellClick ? () => onCellClick('stock', r) : undefined} />
                <Td v={r.cumulVendu}   f={fmt} bold onClick={onCellClick ? () => onCellClick('cumul', r) : undefined} />
                <Pct v={r.pctVenduLivre} />
                <Td v={r.periodeVendu} f={fmt} bold onClick={onCellClick ? () => onCellClick('periode', r) : undefined} />
                <Td v={r.chiffreAffaire} bold onClick={onCellClick ? () => onCellClick('ca', r) : undefined} />
                <TdDash />
                <TdDash />
                <TdDash />
                <TdDash />
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr style={{ background: '#363c48' }}>
            <td colSpan={2} style={td({ background: '#363c48', color: '#fff', fontWeight: 700, textAlign: 'left', borderRight: BORD_SEP, borderLeft: 'none', borderBottom: '2px solid #c8c8c8' })}>Total</td>
            <Td v={tot.stockInitial} f={fmt} bold foot />
            <Td v={tot.cumulVendu}   f={fmt} bold foot />
            <Pct v={totPct} foot />
            <Td v={tot.periodeVendu} f={fmt} bold foot />
            <Td v={tot.chiffreAffaire} bold foot />
            <TdDash foot />
            <TdDash foot />
            <TdDash foot />
            <TdDash foot />
          </tr>
        </tfoot>
      </table>
      </div>
    </div>
  );
};

export default TableauStockDestockage;
